<!-- @format -->

<template>
  <div>
    <!-- Hamburger Icon -->
    <button
      @click="toggleMenu"
      class="fixed top-3 right-4 z-50 bg-[#00aa84] p-2 rounded-lg focus:ring-2 transition focus:ring-teal-700 hover:bg-teal-700 text-white"
    >
      <svg
        v-if="!isOpen"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="2"
        stroke="currentColor"
        class="w-6 h-6"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M4 6h16M4 12h16M4 18h16"
        />
      </svg>

      <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="2"
        stroke="currentColor"
        class="w-6 h-6"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
    </button>

    <!-- Fullscreen Navigation Menu -->
    <transition name="fade">
      <div
        v-if="isOpen"
        class="fixed inset-0 bg-white flex flex-col items-start lg:pl-24 px-4 pt-4 md:pt-8 z-50 h-[100dvh] overflow-y-auto overscroll-contain pb-32"
      >
        <div>
          <img
            :src="$t('overlayLogo.src')"
            class="w-[150px] md:w-[200px] mb-2 md:mb-4 min-h-[100px]"
            :alt="$t('logo.alt')"
          />
        </div>
        <section
          class="flex flex-col md:grid md:grid-cols-2 lg:flex lg:flex-row w-full items-start gap-x-[55px]"
          id="mra-main-nav"
        >
          <NavigationLinks @close="closeMenu" />
        </section>
        <img
          src="@/assets/Topography-aqua-green.svg"
          alt=""
          class="hidden md:block fixed -bottom-[100px] md:w-[50%] h-auto bottom-0 right-0"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import NavigationLinks from "@/components/NavigationLinks.vue";
export default {
  components: { NavigationLinks },
  data() {
    return { isOpen: false };
  },

  computed: {
    // current locale from the route (fallback to i18n or 'en')
    locale() {
      return this.$route?.params?.locale || this.$i18n?.locale || "en";
    },
    // parent section if you nest under "/:locale/business-plan"
    section() {
      return this.$route?.meta?.section || "business-plan";
    },
  },

  methods: {
    toggleMenu() {
      this.isOpen = !this.isOpen;
    },
    closeMenu() {
      this.isOpen = false;
    },
    // locale-aware path builder for simple slug paths
    lp(slug) {
      const raw = String(slug || "");

      // If slug starts with '/', treat as absolute; skip locale/section entirely
      if (raw.startsWith("/")) {
        return raw.replace(/([^:]\/)\/+/g, "$1");
      }

      const clean = raw.replace(/^\/+/, "");
      return `/${this.locale}/${this.section}/${clean}`.replace(
        /([^:]\/)\/+/g,
        "$1",
      );
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

ul li a {
  display: block;
  text-align: center;
  text-wrap: balance;
}
</style>
